import axios from 'axios';
import {api} from "../config";
import jwtToken from '../helpers/jwt-token';

export default {
    postLogin(form) {
        return axios.post(api.login, form);
    },

    postRegister(form) {
        let formData = new FormData();

        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });

        return axios.post(api.register, formData,{ headers: {
                'Content-Type': 'multipart/form-data'
            }});
    },

    // send password resets email
    postPasswordReset(email) {
        return axios.post(api.password_reset, {
            email: email
        });
    },

    // saves new password when password reset
    postPasswordResetNew(form) {
        return axios.post(api.password_reset_new, form);
    },

    //send authenticator reset email
    resetAuthenticatorMail(email) {
        return axios.post(api.reset_authenticator_mail, {
            email: email
        });
    },

    //set authenticator disabled
    resetAuthenticator(form) {
        return axios.post(api.reset_authenticator, form);
    },

    postRegisterVerify(token) {
      return axios.post(api.register_verify, {
          token: token
      });
    },

    postResendRegisterVerify(token, user_id) {
      return axios.post(api.resend_register_verify, {
          token: token,
          user_id: user_id
      });
    },

    postInvestorApplication(form) {
        // convert to form data
        let formData = new FormData();

        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });

        // post as muiltpart since there's
        return axios.post(api.investors.apply, formData,{ headers: {
                'Content-Type': 'multipart/form-data'
        }});
    },

    postBusinessOwnerApplication(form, bo_six_months_bank_statement_uploaded, bo_all_directors_ic_uploaded, bo_other_docs_file_uploaded) {
        // convert to form data
        let formData = new FormData();

        Object.keys(form).forEach((key) => {
            if(key === 'bo_all_directors_ic') {
                form[key].forEach((director_ic, index) => {
                    formData.append(
                      'bo_all_directors_ic['+ index +']',
                      director_ic
                    );
                });
            }else if (key === 'bo_other_docs_file') {
                form[key].forEach((other_doc,index) => {
                    formData.append(
                        'bo_other_docs_file['+ index + ']',
                        other_doc
                    );
                })
            } else if (key === 'bo_six_months_bank_statement') {
                form[key].forEach((bank_statement,index) => {
                    formData.append(
                        'bo_six_months_bank_statement[' + index + ']',
                        bank_statement
                    )
                })
            } else if (key === 'bo_registration_number') {
                form[key] = form[key].replace(/[-]/g, '');
                formData.append(key, form[key]);
            } else {
                if (key !== 'bo_six_months_bank_statement_uploaded' || key !== 'bo_all_directors_ic_uploaded' || key !== 'bo_other_docs_file_uploaded') {
                    formData.append(key, form[key]);
                }
            }
        });

        if (bo_six_months_bank_statement_uploaded.length > 0) {
            bo_six_months_bank_statement_uploaded.forEach((existingFile, index) => {
                let data = {id: existingFile['id'], name: existingFile['name'], path: existingFile['path']}
                formData.append('bo_six_months_bank_statement_existing[' + index + ']', JSON.stringify(data));
            })
            
        }
        if (bo_all_directors_ic_uploaded.length > 0) {
            bo_all_directors_ic_uploaded.forEach((existingFile, index) => {
                let data = {id: existingFile['id'], name: existingFile['name'], path: existingFile['path']}
                formData.append('bo_all_directors_ic_existing[' + index + ']', JSON.stringify(data));
            })
            
        }
        if (bo_other_docs_file_uploaded.length > 0) {
            bo_other_docs_file_uploaded.forEach((existingFile, index) => {
                let data = {id: existingFile['id'], name: existingFile['name'], path: existingFile['path']}
                formData.append('bo_other_docs_file_existing[' + index + ']', JSON.stringify(data));
            })
        }

        // post as muiltpart since there's
        return axios.post(api.business_owners.apply, formData,{ headers: {
                'Content-Type': 'multipart/form-data'
            }});
    },

    saveDraft(form, identity_type, selected_birthday_day, selected_birthday_month, selected_birthday_year, bo_personal_phonenumber, business_phonenumber, bo_industry_select,
        bo_six_months_bank_statement_uploaded, bo_all_directors_ic_uploaded, bo_other_docs_file_uploaded, is_ekyc_verified) {
        let formData = new FormData();

        Object.keys(form).forEach((key) => {
            if(key === 'bo_all_directors_ic') {
                form[key].forEach((director_ic, index) => {
                    formData.append(
                      'bo_all_directors_ic['+ index +']',
                      director_ic
                    );
                });
            } else if (key === 'bo_other_docs_file') {
                form[key].forEach((other_doc,index) => {
                    formData.append(
                        'bo_other_docs_file['+ index + ']',
                        other_doc
                    );
                })
            } else if (key === 'bo_six_months_bank_statement') {
                form[key].forEach((bank_statement,index) => {
                    formData.append(
                        'bo_six_months_bank_statement[' + index + ']',
                        bank_statement
                    )
                })
            } else if (key === 'bo_registration_number') {
                if (form[key] != null) {
                    form[key] = form[key].replace(/[-]/g, '');
                    formData.append(key, form[key]);
                }
            } else {
                if (key !== 'bo_six_months_bank_statement_uploaded' || key !== 'bo_all_directors_ic_uploaded' || key !== 'bo_other_docs_file_uploaded') {
                    formData.append(key, form[key]);
                }
            }
        });

        formData.append('identity_type', identity_type)
        formData.append('selected_birthday_day', selected_birthday_day)
        formData.append('selected_birthday_month', selected_birthday_month)
        formData.append('selected_birthday_year', selected_birthday_year)
        formData.append('bo_personal_phonenumber', bo_personal_phonenumber)
        formData.append('business_phonenumber', business_phonenumber)
        formData.append('bo_industry_select', bo_industry_select)
        formData.append('is_ekyc_verified', is_ekyc_verified)

        if (bo_six_months_bank_statement_uploaded.length > 0) {
            bo_six_months_bank_statement_uploaded.forEach((existingFile, index) => {
                let data = {id: existingFile['id'], name: existingFile['name'], path: existingFile['path']}
                formData.append('bo_six_months_bank_statement_existing[' + index + ']', JSON.stringify(data));
            })
            
        }
        if (bo_all_directors_ic_uploaded.length > 0) {
            bo_all_directors_ic_uploaded.forEach((existingFile, index) => {
                let data = {id: existingFile['id'], name: existingFile['name'], path: existingFile['path']}
                formData.append('bo_all_directors_ic_existing[' + index + ']', JSON.stringify(data));
            })
            
        }
        if (bo_other_docs_file_uploaded.length > 0) {
            bo_other_docs_file_uploaded.forEach((existingFile, index) => {
                let data = {id: existingFile['id'], name: existingFile['name'], path: existingFile['path']}
                formData.append('bo_other_docs_file_existing[' + index + ']', JSON.stringify(data));
            })
            
        }

        // post as muiltpart since there's
        return axios.post(api.business_owners.save_draft, formData,{ headers: {
                'Content-Type': 'multipart/form-data'
            }});
    },

    retrieveDraft() {
        return axios.get(api.business_owners.retrieve_draft);
    },

    logBusinessOwnerApplication(error) {
        return axios.post(api.business_owners.log_application, {
            error: error
        });
    },

    postNewInvestment(form) {
        return axios.post(api.investors.new_investment, form);
    },

    postInvestorUpgradeToPremium(form) {
        // convert to form data
        let formData = new FormData();

        // loop through inv_income_slip
        Object.keys(form).forEach((key) => {
            if(key === 'inv_income_slip') {
                form[key].forEach((asset, index) => {
                    formData.append(
                        'inv_income_slip['+ index +']',
                        asset
                    );
                });
            } else {
                formData.append(key, form[key]);
            }
        });

        Object.keys(form).forEach((key) => {
            if(key === 'inv_personal_assets') {
                form[key].forEach((asset, index) => {
                    formData.append(
                        'inv_personal_assets['+ index +']',
                        asset
                    );
                });
            } else {
                formData.append(key, form[key]);
            }
        });

        Object.keys(form).forEach((key) => {
            if(key === 'inv_additional_documents') {
                form[key].forEach((asset, index) => {
                    formData.append(
                        'inv_additional_documents['+ index +']',
                        asset
                    );
                });
            } else {
                formData.append(key, form[key]);
            }
        });

        // post as muiltpart since there's
        return axios.post(api.investors.premium_upgrade, formData,{ headers: {
                'Content-Type': 'multipart/form-data'
            }});
    },

    getPhoneCountryCode() {
        return axios.get(api.phone_country_codes);
    },

    getInvestorRegistrationConstants() {
        return axios.get(api.investor_registration_constants);
    },

    getInvestorRiskSettings() {
        return axios.get(api.investors.get_investor_risk_settings);
    },

    updateInvestorRiskSettings(form) {
        let formData = new FormData();

        Object.keys(form).forEach((key) => {
            formData.append(key, form[key]);
        });

        return axios.post(api.investors.update_investor_risk_settings, formData,{ headers: {
            'Content-Type': 'multipart/form-data'
        }});
    },
}
